import Questionary from "@/views/Home/components/Questionary";
import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import RarrIcon from "@/assets/images/icons/rarr-btn.svg?inline";

import { mapGetters } from "vuex";

export default {
  name: "home",

  data() {
    return {
      isFixHeight: false,

      homeLoading: false
    };
  },

  created() {
    if (localStorage.getItem("AUTH_TOKEN")) {
      this.homeLoading = true;
    }
  },

  mounted() {
    if (this.currentUser && this.currentUser.id) {
      this.checkUser(this.currentUser);
    }
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    })
  },

  methods: {
    checkUser(user) {
      if (user.id) {
        // redirect HomeOwners after signUp
        if (user.isSeller && this.$store.state.isSignUp) {
          this.$router.replace({
            name: "homeowners"
          });
        } else {
          this.$router.replace({
            name: "properties"
          });
        }
      } else {
        this.homeLoading = false;
      }

      this.$toasted.clear();
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    }
  },

  watch: {
    currentUser: function(newV) {
      this.checkUser(newV);
    }
  },

  components: {
    Questionary,
    LoadingIcon,
    RarrIcon
  }
};
